module.exports = __webpack_public_path__ + "images/emoji/revolving_hearts.da8244706b7a7b785fad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/revolving_hearts.png
// module id = RHDX
// module chunks = 2